import * as R from 'ramda';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import getRiskOptions from 'selectors/getRiskOptions';
import getContentTagOptions from 'selectors/getContentTagOptions';
import FormBuilder from 'components/forms/FormBuilder/FormBuilder';
import api from 'server/api';
import reduxFetch from 'utils/reduxFetch';
import setFilter from 'state/actions/setFilter';
import {
  defaultValues,
  getInitialAlertIndexFilterValues,
} from '../../shared/selectors/getInitialAlertFilterValues';

export const getFields = createSelector(
  getRiskOptions,
  getContentTagOptions,
  (riskOptions, tagOptions) => ([
    {
      type: 'text',
      name: 'search',
      label: 'Search',
    },
    {
      type: 'combobox',
      name: 'geographies',
      label: 'Geographies',
      multiple: true,
      itemToState: R.applySpec({
        label: R.prop('title'),
        value: R.prop('slug'),
      }),
      renderResult: R.prop('title'),
      fetchFn: (query, selectedItems) => (
        reduxFetch({
          fetch: api('geography', 'get'),
          perPage: 6,
          filters: {
            search: query,
            'exclude.slug': selectedItems,
          },
        })
      ),
    },
    {
      type: 'date',
      range: true,
      name: 'dateRange',
      label: 'Date range',
      preDefined: [
        {
          name: '3 months',
          from: {
            m: 3,
          },
        },
        {
          name: '6 months',
          from: {
            m: 6,
          },
        },
        {
          name: '12 months',
          from: {
            m: 12,
          },
        },
      ],
    },
    {
      type: 'mc',
      name: 'riskTypes',
      label: 'Alert types',
      multiple: true,
      options: riskOptions,
    },
    {
      type: 'mc',
      name: 'contentTags',
      label: 'Tags',
      multiple: true,
      options: tagOptions,
    },
  ]),
);

const mapStateToProps = state => ({
  defaultValues,
  initialValues: getInitialAlertIndexFilterValues(state),
  fields: getFields(state),
  filter: true,
  autoSubmit: true,
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (data) => {
    dispatch(setFilter(data, ['page']));
  },
});

const AlertsFilters = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormBuilder);

export default AlertsFilters;
